module.exports = __webpack_public_path__ + "static/media/whole-word-default.a4bf5724.svg";